import {z} from 'zod';

function typedObjectKeys<T extends Record<string, unknown>>(obj: T) {
  return Object.keys(obj) as (keyof T extends string ? keyof T : never)[];
}

/**
 * Creates a ZodEnum from a keys of a ZodObject.
 *
 * @example
 * const obj = z.object({a: z.number(), b: z.number()});
 * const enum = zodEnumFromObjectKeys(obj);
 *
 * enum.parse('a'); // => 'a'
 */
export function zodEnumFromObjectKeys<T extends z.ZodRawShape>(obj: z.ZodObject<T>) {
  const [first, ...rest] = typedObjectKeys(obj.shape); // https://github.com/colinhacks/zod/discussions/839#discussioncomment-6488540
  return z.enum([first!, ...rest]);
}
